const FreeNumberTypes = {
  STANDARD: "standard",
  SILVER: "silver",
  GOLD: "gold"
};

export default FreeNumberTypes;
